<script>
    import SocialLink from './SocialLink.svelte';
</script>


<div class="row mb-3">
	<div class="m-auto mt-3 col-sm-12 col-lg-8">
		<div class="d-flex my-auto justify-content-center">
			<SocialLink href="https://www.twitter.com/plopadop" src="./twitter.svg" alt="Twitter logo" />
			<SocialLink href="https://github.com/ArtisanSelects/wordle-cheater" src="./github.svg" alt="Github logo" />
		</div>
	</div>
</div>